import {init} from "aos";
import {Component} from "../interface/component";

export class AosInit implements Component {
    init() {
        init({once: true});
        offset: 120,
        //Hack - for whatever reason AOS is screwing up until window resize/reflow
        window.dispatchEvent(new Event('resize'));
    }
}
